module.exports = __webpack_public_path__ + "img/helmet-battle.20fb6f1d.svg";